import * as Yup from 'yup';

import { businessModelOptions as defaultBusinessModelOptions, numberOfYearOptions } from '../../../defaultFilters';

export const useBusinessModelFilter = ({ setFilters }) => {
  const businessModelOptions = defaultBusinessModelOptions;

  const formSchema = Yup.object().shape({
    bizModels: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
    bizModelYears: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.number(),
      })
      .nullable()
      .default(null),
  });

  const onSubmit = ({ bizModels, bizModelYears }) => {
    const filters = { bizModels };
    if (bizModels && bizModels.length > 0) {
      filters.bizModelYears = bizModelYears;
    } else {
      filters.bizModelYears = null;
    }
    setFilters(filters);
  };

  const getInitialValues = (bizModels, bizModelYears) => {
    // If bizModelYears is just a number, find the matching option
    let normalizedYears = bizModelYears;
    if (typeof bizModelYears === 'number') {
      normalizedYears = numberOfYearOptions.find((option) => option.value === bizModelYears);
    }

    return {
      bizModels: bizModels || [],
      bizModelYears: normalizedYears || numberOfYearOptions[0],
    };
  };

  return {
    formSchema,
    onSubmit,
    businessModelOptions,
    getInitialValues,
  };
};
